import React, { useState } from 'react';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import { useModal } from "../components/Modal";

const VybaveniDomu = () => {

    Fancybox.bind('[data-fancybox="gallery"]', {});

    const [activeTab, setActiveTab] = useState("01");

    const { handleShowModal } = useModal();

    const descriptions = {
        "01": [
            "Svařovaná ocelová konstrukce s antikorozním nátěrem",
            "dřevěné hranoly",
            "cementotřískové desky",
            "difuzní a parotěsné fólie",
            "tepelná izolace (podlaha/stěny/strop): 250/250/250mm"
        ],
        "02": [
            "Plastová okna s trojskly s šestikomorový systém, instalační hloubka: 85 mm",
            "systém s centrálním těsněním (3 těsnění), testem potvrzená třída odolnosti proti vloupání RC2, k dispozici v mnoha barevných variantách",
            "2x dvoukřídlé 1300 x 1500 mm",
            "1x neotevíratelné 1800x2100 mm",
            "1x jednokřídlé 600x600 mm",
            "1x jednokřídlé 600x400 mm",
            "1x balkonové okno 1800x2100 mm",
            "elektrické venkovní žaluzie s ovládacími prvky"
        ],
        "03": [
            "Ocelová vazníková střešní konstrukce vyplněná minerální vatou",
            "plechová střešní krytina Satjam Rapid s příslušenstvím",
            "vysoko difuzní střešní membrána Jutadach",
            "střešní latě a kontralatě, komínová průchodka",
            "pozinkované okapové žlaby a svody",
            "8x panel fotovoltaiky 3,6 kWp"
        ],
        "04": [
            "Sádrokartonové desky",
            "profily UW a CW 100 mm",
            "Zvukově tepelná izolace Rockwool Rockmin Plus 100 mm",
            "Rigips RBI 2 000×1 250×12,5 mm impregnovaná",
            "zpevnění ploch na vybraných místech pro uchycení nábytku a příslušenství",
            "bílý hygienický nátěr"
        ],
        "05": [
            "Fasádní EPS 70 100 mm",
            "lepící pěna Soudal ETICS BOND",
            "armovací síťka Vertex 117",
            "barevná silikonová omítka Weber dle vzorníku (zrnitost 1,5mm)"
        ],
        "06": [
            "Elektrické podlahové vytápění",
            "tepelné čerpadlo (vzduch – vzduch 7 kW)",
            "krbová kamna (7 kW)",
            "elektrický žebříkový radiátor do koupelny"
        ],
        "07": [
            "Keramické obklady a dlažby dle výběru zákazníka (do 329 Kč/m2)",
            "závěsný WC modul GEBERIT",
            "sprcha nebo vana dle preferencí zákazníka",
            "umyvadlo 60 cm",
            "nástěnné a sprchové baterie",
            "elektrický bojler 100l",
            " vnitřní rozvody vody a kanalizace"
        ],
        "08": [
            "3x interiérové dveře 800x2000 mm (3700 Kč/ks včetně zárubní)",
            "1x interiérové dveře 700x2000 mm (3700 Kč/ks včetně zárubní)",
            "keramické dlažby a plovoucí podlahy (do 329 Kč/m2)"
        ],
        "09": [
            "3x 400V, 32 A, 50 Hz",
            "rozvaděč HAGER 60 modulů",
            "jističe EATON",
            "světelné a zásuvkové okruhy",
            "okruh pro topení",
            "zásuvky a vypínače Schneider Asfora",
            "12x 12 W LED osvětlení",
            "instalace fotovoltaiky s bateriovým úložištěm",
            "zpráva o revizi elektrického zařízení, dle ČSN",
            "schéma zapojení rozvodnice"
        ],
        "10": [
            "1x vchodové venkovní dveře plastové 1000x2000 mm – tepelně izolované, včetně kování a zámku s cylindrickou vložkou",
            "1x balkonové dveře plastové - trojskla s šestikomorový systém 1800x2100 mm"
        ]
    };

    return (
        <div id="content" className="vybaveni-domu">
            <div className="container">
                <h1>
                    <strong>Vybavení domů</strong><br />
                    standardy zahrnuté v ceně
                </h1>
                <div className="qBox">
                    <div className="item">
                        <span>katalogové domy jsou navrženy jako velmi úsporné v energetické třídě B</span>
                        <strong>prohlédněte si používané materiály a vybavení domů na klíč</strong>
                    </div>
                </div>
                <div className="descriptions">
                    <h4>Podrobný popis</h4>
                    <div className="inner">
                        <div className="nav-menu">
                            <ul>
                                {Object.keys(descriptions).map(tab => (
                                    <li key={tab} onClick={() => setActiveTab(tab)} className={activeTab === tab ? "active" : ""}>
                                        {tab === "01" && "Konstrukce"}
                                        {tab === "02" && "Okna"}
                                        {tab === "03" && "Střecha"}
                                        {tab === "04" && "Vnitřní stěny"}
                                        {tab === "05" && "Fasáda"}
                                        {tab === "06" && "Vytápění"}
                                        {tab === "07" && "Sanita"}
                                        {tab === "08" && "Interiér"}
                                        {tab === "09" && "Elektroinstalace"}
                                        {tab === "10" && "Dveře"}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="toggle-text">
                            {descriptions[activeTab].map((text, index) => (
                                <p key={index}>{text}</p>
                            ))}
                        </div>
                    </div>
                </div>

                <h2>Fotogalerie</h2>
                <div className="gallery gallery-prew">
                    <div className="gallery-items">
                        <a className="gal-item" href="./images/gallery/01.jpg" data-fancybox="gallery">
                            <img src="./images/gallery/01.jpg" alt="img01" loading="lazy" />
                        </a>
                        <a className="gal-item" href="./images/gallery/02.jpg" data-fancybox="gallery">
                            <img src="./images/gallery/02.jpg" alt="img02" loading="lazy" />
                        </a>
                        <a className="gal-item" href="./images/gallery/03.jpg" data-fancybox="gallery">
                            <img src="./images/gallery/03.jpg" alt="img03" loading="lazy" />
                        </a>
                        <a className="gal-item text" href="/galerie">
                            <span>Více<br /> fotografií</span>
                        </a>
                    </div>
                </div>
                <div className="extra-info">
                    <div className="extra-text">
                        <h3>Co si zákazník libovolně vybírá</h3>
                        <ul>
                            <li>Dekor a materiál podlah (v ceně domu započtena sazba 329 Kč/m2)</li>
                            <li>Obklady do koupelny (v ceně domu započtena sazba 329 Kč/m2)</li>
                            <li>Dekor a styl interiérových dveří</li>
                            <li>Osvětlení, zásuvky a vypínače</li>
                            <li>Vanu nebo sprchový kout</li>
                            <li>Toaletu a umyvadlo</li>
                        </ul>
                    </div>
                    <div className="extra-banner">
                        <h2>
                            Máte zájem o individuální
                            vybavení domu?
                        </h2>
                        <p>
                            Neváhejte nás kontaktovat. Upravíme vám nabídku
                            dle vašich potřeb a požadavků.
                        </p>
                        <button onClick={handleShowModal} className="bttn center">Kontaktní formulář</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default VybaveniDomu;